<template>
  <transition name="zoomIn">
    <div
      class="mask"
      v-if="show"
      :style="{ animationDuration: routeFrom ? '0s' : '.4s' }"
    >
      <div class="show-box">
        <!-- 正在直播的弹窗 -->
        <div class="head-box" :class="{ novice_class: isNoviceClass }">
          <div class="inner-box">
            <img
              :src="
                '/static/img/course/iconbg/' + subType + '/' + (imgNum % 6 == 0 ? '6' : imgNum % 6) + '.png'
              "
            />
            <!-- 动画盒子 -->
            <div class="animation_lottie"></div>
          </div>
        </div>
        <p class="lesson-name">{{ lessonName }}</p>
        <p class="lesson-state">开始学习</p>

        <!-- 按钮 -->
        <div class="btn-box">
          <div v-show="cancal" class="chongshu cursor" @click="cancelE">
            {{ cancal }}
          </div>
          <div v-show="btn" class="chongshu cursor" @click="defaultAlert">
            {{ btn }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/*
	1、正在上课需要传递的参数：
	imgNum：课时列表中的哪一课时(数字字符串均可)
	lessonName：课时名称，

	2、show:父组件传递fasle,true来控制盒子组件的显示隐藏（默认为显示）
	3、按钮功能
	      文字描述  事件对应字段 文案对应字段
	左边   取消（）  cancelEvent    cancle

	右边    确定       ensure         btn

	4、sameOne：加粗大的字
	   sameTwo：加粗大的字
	   errorNum：为小的不加粗的字
	 */
import { mapState, mapActions, mapMutations } from "vuex";
import lottie from "lottie-web-limi";
export default {
  data() {
    return {
      basicUrl: "/static/img/course/number/",
      strArr: [],
			routeFrom: !!this.$route.params.from,
			anim: ''
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    btn: {
      type: String,
      default: ""
    },
    cancal: {
      type: String,
      default: ""
    },
    //粗体大字
    sameOne: {
      type: String,
      default: ""
    },
    //粗体大字
    sameTwo: {
      type: String,
      default: ""
    },
    //错误代码字段
    errorNum: {
      type: Number,
      default: null
    },
    //课程名称字段
    lessonName: {
      type: String,
      default: ""
    },
    //传递num数字展示对应的数字图片
    imgNum: {
      default: ""
    },
    subType: {
      type: String,
      default: ""
    }
  },
  created() {
    if (this.routeFrom) {
      setTimeout(() => {
        this.routeFrom = false;
      }, 500);
    }
  },
  computed: {
    ...mapState(["subject", "isNoviceClass"])
  },
  methods: {
    //=>取消事件
    cancelE() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLivingCancel",
        data: {}
      });
      this.$emit("cancelEvent");
    },
    //确定事件
    defaultAlert() {
      this.$emit("ensure");
    },
    splitIndex(num) {
      let str = num + "";
      let strArr = [];
      let len = str.length;
      for (var i = 0; i < len; i++) {
        strArr.push(str[i]);
      }
      return strArr;
    }
  }
};
</script>
<style lang="less" rel="stylesheet/stylus" scoped>
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 16px;

  /*五个小竖条*/
  .animation_lottie {
    width: 129px;
    height: 129px;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 10;
  }
  .show-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 434px;
    height: 354px;
    border-radius: 16px;
    text-align: center;
    background: #ffffff;
    // animation: alertAnimate .5s cubic-bezier(0.645, 0.045, 0.150, 1);
    p {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      -webkit-align-items: center;
      align-items: center;
    }
    .head-box {
      margin-top: 30px;
      height: 129px;
      width: 129px;
      position: relative;
      box-sizing: border-box;
      .inner-box {
        height: 129px;
        width: 129px;
        position: absolute;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 129px;
          height: 129px;
        }
        .animate-box {
          width: 100px;
          height: 50px;
          position: absolute;
          left: 0px;
          top: 0px;
          i {
            display: inline-block;
            vertical-align: middle;
            width: 4px;
            background: #fff;
            margin-left: 4px;
            border-radius: 2px;
          }
        }
      }
    }
    .lesson-name {
      display: block;
      width: 209px;
      height: 18px;
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Light;
      font-weight: 300;
      color: #003057;
      margin: 24px 0 15px 0;
      line-height: 18px;
      white-space: nowrap;
      overflow : hidden;/*必须结合的属性,当内容溢出元素框时发生的事情*/
      text-overflow: ellipsis;/*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
    }
    .lesson-state {
      font-size: 28px;
      color: #003057;
      line-height: 28px;
      padding-bottom: 30px;
      font-weight: bold;
      font-family: PingFang_Medium;
    }
    .btn-box {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 80px;
      border-top: 1px solid #9ebfc8;
      div {
        flex: 1;
        box-sizing: border-box;
        font-size: 24px;
        color: #007a9c;
        line-height: 80px;
      }
      div:nth-child(2) {
        box-sizing: border-box;
        border-left: 1px solid #9ebfc8;
        line-height: 80px;
      }
      div:hover {
        color: #003057;
      }
    }
  }
}
.zoomIn-enter-active,
.zoomIn-enter {
  animation: zoomIn 0.4s cubic-bezier(0.645, 0.045, 0.15, 1);
}
.zoomIn-leave-active, .zoomIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation: zoomIn 0.4s reverse cubic-bezier(0.645, 0.045, 0.15, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/course/course_alert.vue